import { createBrowserRouter } from 'react-router-dom';

import { useRoutes } from 'app/providers/RouterProvider/hooks/useRoutes';

import type { UserRole } from 'shared/types';

export const useRouter = (role: UserRole) => {
  const routes = useRoutes(role);

  return createBrowserRouter(routes);
};
